import { render, staticRenderFns } from "./appealReviewStatusModal.vue?vue&type=template&id=256dc6f1&scoped=true"
import script from "./appealReviewStatusModal.vue?vue&type=script&lang=js"
export * from "./appealReviewStatusModal.vue?vue&type=script&lang=js"
import style0 from "./appealReviewStatusModal.vue?vue&type=style&index=0&id=256dc6f1&prod&lang=scss&scoped=true"
import style1 from "./appealReviewStatusModal.vue?vue&type=style&index=1&id=256dc6f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256dc6f1",
  null
  
)

export default component.exports